__turbopack_context__.v({
  "card": "StatCard-module-scss-module__WLwoTW__card",
  "cardWithGrid": "StatCard-module-scss-module__WLwoTW__cardWithGrid",
  "iconBg": "StatCard-module-scss-module__WLwoTW__iconBg",
  "label": "StatCard-module-scss-module__WLwoTW__label",
  "value": "StatCard-module-scss-module__WLwoTW__value",
});
